import { FetchError } from '@frontend/api';
import { isObject } from '@frontend/utils';

import type { TeamMemberUploadValidation } from './types';

const isCodedList = (value: unknown): boolean =>
  Array.isArray(value) &&
  value.every((item) => isObject(item) && typeof item.code === 'string');

/**
 * The preview endpoint answers a file it can't publish with a 400 whose body
 * is a TeamMemberUploadValidation. Any other failure (auth, throttling, a
 * missing file, a server error) has some other shape, so this returns null and
 * callers fall back to a generic message.
 */
export const getTeamMemberUploadValidation = (
  error: unknown,
): TeamMemberUploadValidation | null => {
  if (!(error instanceof FetchError)) {
    return null;
  }

  const payload = error.originalResponse;
  if (
    !isObject(payload) ||
    !isCodedList(payload.errors) ||
    !isCodedList(payload.warnings)
  ) {
    return null;
  }

  return payload as unknown as TeamMemberUploadValidation;
};
